<div
  *ngIf="itemsTotal"
  [attr.id]="module.slug || null"
  [attr.data-ancnav]="module.slug || null"
  [attr.data-exercise-is-slider]="module.isSlider"
  [attr.data-exercise-total-columns]="module.totalColumns"
  class="content-module exercise-module"
>
  <div class="exercise__inner">

    <div class="exercise__top" *ngIf="module.title || (module.isSlider && !isMobile)">
      <h3 class="title--h1alt" *ngIf="module.title">{{ module.title }}</h3>
      <div class="slider-arrows slider-arrows--exercise"  *ngIf="module.isSlider && !isMobile">
        <div class="icon icon-arrow icon-arrow--move-left slider-arrow slider-arrow--prev" [id]="'slider-arrow-prev--exercise-' + module.slug"></div>
        <div class="icon icon-arrow icon-arrow--move-right slider-arrow slider-arrow--next" [id]="'slider-arrow-next--exercise-' + module.slug"></div>
      </div>
    </div>

    <div class="exercise__bottom" #exerciseBottom>

      <app-slider
        *ngIf="module.isSlider && !isMobile"
        [module]="module"
        [additionalConfig]="{
          navigation: {
            prevEl: '#slider-arrow-prev--exercise-' + module.slug,
            nextEl: '#slider-arrow-next--exercise-' + module.slug
          }
        }"
      >
        <div class="tile-wrapper swiper-slide" *ngFor="let exerciseTile of module.exercises;">
          <app-tile
            [tile]="exerciseTile"
            [format]="'medium'"
            [context]="'slider'"
          ></app-tile>
        </div>
      </app-slider>

      <ng-container *ngIf="!module.isSlider || (module.isSlider && isMobile)">
        <div class="exercise__item" *ngFor="let exerciseTile of itemsToDisplay" #exercisesItems>
          <app-tile
            [tile]="exerciseTile"
            [format]="'medium'"
          ></app-tile>
        </div>
      </ng-container>

      <div class="exercise__see-more" *ngIf="module.isSlider && isMobile">
        <button
          *ngIf="itemsToDisplay.length < itemsTotal"
          class="btn btn--sm"
          (click)="displayMoreItems()"
        >Voir plus</button>
      </div>

    </div>

  </div>
</div>
